module.exports = __webpack_public_path__ + "img/share_title-bg_blue.ceab80c1.png";